import { render, staticRenderFns } from "./driverDan.vue?vue&type=template&id=473dca74&scoped=true&"
import script from "./driverDan.vue?vue&type=script&lang=js&"
export * from "./driverDan.vue?vue&type=script&lang=js&"
import style0 from "./driverDan.vue?vue&type=style&index=0&id=473dca74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473dca74",
  null
  
)

export default component.exports